var map = {
	"./0.png": 33,
	"./1.png": 34,
	"./10.png": 35,
	"./11.png": 36,
	"./12.png": 37,
	"./13.png": 38,
	"./14.png": 39,
	"./15.png": 40,
	"./16.png": 41,
	"./17.png": 42,
	"./18.png": 43,
	"./19.png": 44,
	"./2.png": 45,
	"./20.png": 46,
	"./21.png": 47,
	"./3.png": 48,
	"./4.png": 49,
	"./5.png": 50,
	"./6.png": 51,
	"./7.png": 52,
	"./8.png": 53,
	"./9.png": 54
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;